"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CachedObservablePromise = void 0;
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const mobx_1 = require("mobx");
const ObservablePromise_1 = require("./ObservablePromise");
class CachedObservablePromise extends ObservablePromise_1.ObservablePromise {
    constructor() {
        super(...arguments);
        this._apiCalls = [];
        this._isInvalidated = true;
    }
    execute(...callArgs) {
        if (this._isWaitingForResponse)
            return this;
        const existingApiCall = this._findApiCall(callArgs);
        if (!existingApiCall) {
            this._isInvalidated = true;
            this._currentCall = this._addApiCall(callArgs);
        }
        else {
            this._currentCall = existingApiCall;
            this.handleSuccess(existingApiCall.result);
            this._promise = Promise.resolve(existingApiCall.result);
        }
        if (!this._isInvalidated) {
            return this;
        }
        mobx_1.runInAction(() => {
            this.isExecuting = true;
        });
        this._isWaitingForResponse = true;
        this._promise = new Promise((resolve, reject) => {
            this._action(...callArgs)
                .then((result) => {
                if (result instanceof Error)
                    this.handleError(result, reject);
                else {
                    if (this._parser) {
                        try {
                            result = this._parser(result, callArgs);
                        }
                        catch (e) {
                            result = e;
                        }
                        if (result instanceof Error) {
                            this.handleError(result, reject);
                            return result;
                        }
                    }
                    this.handleSuccess(result, resolve);
                }
                return result;
            })
                .catch((error) => {
                this.handleError(error, reject);
            });
        });
        return this;
    }
    emptyCache() {
        this._apiCalls = [];
    }
    clone() {
        return new CachedObservablePromise(this._action, this._parser, this.name);
    }
    handleSuccess(result, resolve) {
        this._isInvalidated = false;
        super.handleSuccess(result, resolve);
    }
    handleError(error, reject) {
        this._apiCalls = this._apiCalls.filter(h => h != this._currentCall);
        super.handleError(error, reject);
    }
    _addApiCall(args) {
        const newCall = { args, result: null };
        this._apiCalls.push(newCall);
        return newCall;
    }
    _findApiCall(args) {
        return this._apiCalls.find(c => lodash_isequal_1.default(c.args, args));
    }
}
__decorate([
    mobx_1.action
], CachedObservablePromise.prototype, "handleSuccess", null);
__decorate([
    mobx_1.action
], CachedObservablePromise.prototype, "handleError", null);
exports.CachedObservablePromise = CachedObservablePromise;
